import barba from '@barba/core';
import {destroyScroll, initScroll, scrollNavbar} from "./locootiveScroll";
import {uploadFile} from "../components/upload_file";
import {popupLightbox} from "../components/equipe_popup";
import {lightbox} from "../components/lightbox";
import NavTabSBuilder from "../components/builder_tabs";
import collapse from "../components/builder_collapse";

import {gsap, Power4} from "gsap";
//!$(this).hasClass('noBarba')
if ($('#wpadminbar').length < 1) {
    function contentAnimation() {
        const $content = $('.all-content');

        var tl = gsap.timeline();

        tl.to($content, {
            duration: .5,
            opacity: 0,
            ease: Power4.easeInOut,
        });

        tl.to($content, {
            duration: 1,
            opacity: 1,
            ease: Power4.easeInOut,
        });
    }

    function pageTransition() {
        var tl = gsap.timeline();

        tl.to(".c-transition", {
            duration: .5,
            scaleY: 1,
            transformOrigin: "top",
        });

        tl.to(".c-transition", {
            duration: .5,
            scaleY: 0,
            transformOrigin: "bottom",
        });
    }

    function delay(n) {
        n = n || 500;
        return new Promise((done) => {
            setTimeout(() => {
                done();
            }, n);
        });
    }

    barba.hooks.before(() => {
        destroyScroll();
    })

    barba.hooks.after(() => {
        initScroll();
        scrollNavbar();
        uploadFile();
        popupLightbox();
        lightbox();
        NavTabSBuilder();
        collapse();

        $('a, button').mouseenter(function () {
            $(".cursor-follower").addClass('js-isActive');
        }).mouseleave(function () {
            $(".cursor-follower").removeClass('js-isActive');
        }).click(function () {
            $(".cursor-follower").removeClass('js-isActive');
        });

        ga('set', 'page', window.location.pathname);
        ga('send', 'pageview');
    });

    barba.hooks.afterLeave((data) => {
        /**
         * Change body Class
         */
        var nextHtml = data.next.html;
        var response = nextHtml.replace(/(<\/?)body( .+?)?>/gi, '$1notbody$2>', nextHtml)
        var bodyClasses = $(response).filter('notbody').attr('class')

        $("body").attr("class", bodyClasses);

        var $newPageHead = $('<head />').html(
            $.parseHTML(
                data.next.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0],
                document,
                true
            )
        );

        /**
         * Update meta Head
         */
        var headTags = [
            "script[src*='uutils.fcg']",
            "meta[name='keywords']",
            "meta[name='description']",
            "meta[property^='og']",
            "meta[name^='twitter']",
            'meta[itemprop]',
            'link[itemprop]',
            "link[rel='prev']",
            "link[rel='next']",
            "link[rel='canonical']",
        ].join(',');
        $('head').find(headTags).remove();
        $newPageHead.find(headTags).appendTo('head');
    });

    barba.init({
        transitions: [{
            sync: true,

            async leave(data) {

                $('.menu li').each(function () {
                    $(this).removeClass('current-menu-item');

                    if ($(this).find('a')[0].pathname == data.next.url.path) {
                        $(this).addClass('current-menu-item');
                    }
                });

                const done = this.async();
                contentAnimation();
                pageTransition();
                await delay(500);
                done();
            },
        }]
    });
}


$('.noBarba').each(function () {
    barba.destroy();
})
